<script setup lang='ts'>
import { useCommentListComponent } from '../hooks/comment'
import type { ArticleCommentParams } from '~~/src/server/modules/article/type'
const props = withDefaults(defineProps<{
  param: Omit<ArticleCommentParams, 'pageSize' | 'pageNum'>
  show?: boolean
}>(), {
  show: false,
})
const emits = defineEmits({
  'update:show': (show: boolean) => typeof show === 'boolean',
})
function updateShowHandle(show: boolean) {
  emits('update:show', show)
}

const scrollElRef = ref<HTMLElement>()
const {
  list,
  state,
  pagination,
  getData,
  initHandle,
} = useCommentListComponent(props)
let stop = watch(() => props.show, () => {
  props.show && initHandle()
})
onBeforeUnmount(() => {
  stop()
  stop = null!
})
</script>

<template>
  <div>
    <van-popup
      :show="show"
      safe-area-inset-bottom
      round
      position="bottom"
      :style="{ height: '80vh' }"
      @update:show="updateShowHandle"
    >
      <div h-full flex="~ col" bg-gray-100>
        <div text-center text-title-800 bg-white font-bold py-4 text-4 @click="updateShowHandle(false)">
          <span>全部评论</span>
          <span absolute right-3 top-3 text-6 i-carbon:close />
        </div>
        <div ref="scrollElRef" flex-grow bg-white px-3 overflow-y-auto>
          <base-list v-model:state="state" :el="scrollElRef" @load="getData">
            <ul grid grid-cols-1 gap-4>
              <li v-for="item, index in list" :key="index" class="mb-8">
                <layout-comment-item :index="index" :item="item" />
              </li>
            </ul>
          </base-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang='scss' scoped>
.menu-button {
  --uno: bg-white flex-shrink-0 h-13 leading-13 text-center text-title-600 text-4 mt-2;
  --uno: active:bg-gray-100 transition;
}
  </style>
